import endpoints from '@app/src/api/endpoints'
import { FetchKey, useFetchResource } from '@app/src/api/fetchHooks'
import Permissions from '@app/src/auth/permissions'
import { useAccount } from '@app/src/context/AccountContext'
import useFeatureFlagsByAccessor from '@app/src/hooks/useFeatureFlagsByAccessor'
import { ONE_MINUTE_MS } from '@app/src/wf-constants'

export type SuggestionFile = {
  name: string
  url: string
}

type UseFetchSuggestionFiles = {
  files?: SuggestionFile[]
  isLoadingFiles: boolean
  hasSuggestedAnswersFeature: boolean
}

const useFetchSuggestionFiles = (enabled: boolean): UseFetchSuggestionFiles => {
  const { hasPermission } = useAccount()
  const { orgOrAccessorHasFeature: hasSuggestedAnswersFeature, isLoading: isLoadingFeature } =
    useFeatureFlagsByAccessor({
      featureToggleName: 'suggested-answers',
      enabled: hasPermission(Permissions.TRANSPARENCY_USER),
      priorityValue: false,
    })

  const isQueryEnabled = enabled && hasSuggestedAnswersFeature

  const { data: files, isFetched } = useFetchResource<SuggestionFile[]>({
    endpoint: endpoints.suggestionFiles,
    key: FetchKey.FileRepository,
    shouldShowErrorNotification: false,
    options: {
      refetchOnMount: false,
      enabled: isQueryEnabled,
      staleTime: ONE_MINUTE_MS,
    },
  })

  return {
    files,
    isLoadingFiles: enabled && (isLoadingFeature || (isQueryEnabled && !isFetched)),
    hasSuggestedAnswersFeature,
  }
}

export default useFetchSuggestionFiles
